<template>
    <div class="card dashcard">
        <div class="card-body">
            <div class="form-row">
                <div class="col col-12 col-md-1">
                    <az-input type="ano" label="Ano referência" v-model="referencia" :edicao="false" />
                </div>
                <div class="col col-12 col-md-1">
                    <az-input type="ano" label="Ano calendário" v-model="calendario" />
                </div>
                <div class="col col-12 col-md-1">
                    <az-input type="select" label="Tipo" optionsData="id"
                        :optionsList="[{ id: 'N', search: 'Normal' }, { id: 'S', search: 'Retificadora' }]"
                        v-model="retificadora" />
                </div>
                <div class="col col-12 col-md-1">
                    <az-input label="Número recibo" v-model="recibo" />
                </div>
                <div class="col col-12 col-md-2">
                    <az-input type="select" label="Filtro de Lançamentos" optionsData="id"
                        :optionsList="[{ id: '1', search: 'Pagos e Baixados' }, { id: '2', search: 'Pagos' }]"
                        v-model="status_lancamento" />
                </div>
                <div class="col col-12 col-md-2">
                    <az-input type="select" label="Filtro de Nota Fiscal" optionsData="id"
                        :optionsList="[{ id: 'default', search: 'Sem filtro' }, { id: 'emitida', search: 'Emitida' }]"
                        v-model="filtro_nota_fiscal" />
                </div>
                <div class="col col-12 col-md-2">
                    <az-input label="Filtro de Unidade Operação " icon="far fa-building fa-fw" type="select"
                        placeholder="Todas as unidades" :optionsList="$util.unidades_com_tags(false, true)"
                        optionsData="id_unidade_operacao" v-model="unidade_operacao" />
                </div>
                <div class="col col-12 col-md-2 d-flex flex-column mt-4">
                    <button class="btn btn-outline-success" @click.prevent="gerarDMED"
                        :disabled="$store.state.loading">Gerar
                        DMED</button>
                </div>
            </div>

            <!-- Dispatch -->
            <az-dispatch ref="dispatch" @chunkFinal="terminar_captura()" />

            <div class="progress mt-1 mb-2">
                <div class="indeterminate" v-if="$store.state.loading"></div>
                <div class="determinate" v-else></div>
            </div>
        </div>
    </div>
</template>

<script>
// import _ from "lodash";
import AzInput from "../../shared/forms/AzInput.vue";
import AzDispatch from '../../util/AzDispatch.vue';
// import AzEmptyState from "../../util/AzEmptyState.vue";

export default {
    data() {
        return {
            dados: null,
            referencia: this.$util.hoje().substr(0, 4),
            calendario: this.$util.hoje().substr(0, 4),
            retificadora: "N",
            recibo: "",
            status_lancamento: '1',
            unidade_operacao: "",
            filtro_nota_fiscal: 'default',
            chave: null,
            dmed_fracionado: false
        };
    },

    components: {
        AzInput,
        AzDispatch
    },

    methods: {

        gerarDMED() {
            if (this.dmed_fracionado) {
                this.gerarDMEDFracionado();
            } else {
                this.gerarDMEDSemFracionar();
            }
        },

        gerarDMEDSemFracionar() {
            if (this.retificadora == "S" && this.recibo == "") {
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: "Informe o número do recibo",
                    life: 3000
                });
                return;
            }

            this.$store.commit("loading", true);

            var data = {
                referencia: this.referencia,
                calendario: this.calendario,
                retificadora: this.retificadora,
                recibo: this.recibo,
                status_lancamento: this.status_lancamento,
                unidade_operacao: this.unidade_operacao,
                filtro_nota_fiscal: this.filtro_nota_fiscal
            };

            return this.axios
                .post("/dmed/arquivo", data)
                .then(res => {
                    if (res.status == 200 || res.status == 201) {

                        if (res.data.status_code == 406) {
                            this.$toast.add({
                                severity: "error",
                                summary: "Atenção",
                                detail: res.data.msg,
                                life: 3000
                            });
                            return;
                        }

                        var dataStr = "data:text/plain;charset=utf-8," + encodeURIComponent(res.data);
                        var downloadAnchorNode = document.createElement('a');
                        downloadAnchorNode.setAttribute("href", dataStr);
                        downloadAnchorNode.setAttribute("download", "dmed" + this.referencia + ".txt");
                        document.body.appendChild(downloadAnchorNode);
                        downloadAnchorNode.click();
                        downloadAnchorNode.remove();

                        this.$toast.add({
                            severity: "success",
                            summary: "Atenção",
                            detail: "Arquivo DMED gerado com sucesso.",
                            life: 3000
                        });
                    }
                })
                .finally(() => {
                    this.$store.commit("loading", false);
                });
        },

        gerarDMEDFracionado() {
            if (this.retificadora == "S" && this.recibo == "") {
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: "Informe o número do recibo",
                    life: 3000
                });
                return;
            }

            this.$store.commit("loading", true);

            let referencia = this.referencia;
            let calendario = this.calendario;
            let retificadora = this.retificadora;
            let recibo = this.recibo;
            let status_lancamento = this.status_lancamento;
            let unidade_operacao = this.unidade_operacao;
            let filtro_nota_fiscal = this.filtro_nota_fiscal;

            this.chave = this.$util.uuidv4();
            const infos = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(mes => {
                return {
                    referencia: referencia,
                    calendario: calendario,
                    retificadora: retificadora,
                    recibo: recibo,
                    status_lancamento: status_lancamento,
                    unidade_operacao: unidade_operacao,
                    mes: mes,
                    filtro_nota_fiscal: filtro_nota_fiscal
                };
            });

            this.$refs.dispatch.executar_chunck(
                'financeiro',
                'save_dmed_aux_table',
                infos,
                '',
                {},
                1
            );

            // this.$store.commit("loading", false);
        },

        terminar_captura() {
            this.$store.commit("loading", true);

            this.$nextTick(() => {

                let data = {
                    referencia: this.referencia,
                    calendario: this.calendario,
                    retificadora: this.retificadora,
                    recibo: this.recibo,
                    status_lancamento: this.status_lancamento,
                    unidade_operacao: this.unidade_operacao
                };

                this.axios.post("/dmed/arquivo", data)
                    .then(res => {
                        console.log('res', res);
                        if (res.status == 200 || res.status == 201) {
                            if (res.data.status_code == 406) {
                                this.$toast.add({
                                    severity: "error",
                                    summary: "Atenção",
                                    detail: res.data.msg,
                                    life: 3000
                                });
                                return;
                            }

                            var dataStr = "data:text/plain;charset=utf-8," + encodeURIComponent(res.data);
                            var downloadAnchorNode = document.createElement('a');
                            downloadAnchorNode.setAttribute("href", dataStr);
                            downloadAnchorNode.setAttribute("download", "dmed" + this.referencia + ".txt");
                            document.body.appendChild(downloadAnchorNode);
                            downloadAnchorNode.click();
                            downloadAnchorNode.remove();

                            this.$toast.add({
                                severity: "success",
                                summary: "Atenção",
                                detail: "Arquivo DMED gerado com sucesso.",
                                life: 3000
                            });
                        }
                    })
                    .catch(() => {
                        this.loading = false;
                        this.reloading = false;
                    })
                    .finally(() => {
                        this.$store.commit("loading", false);
                    });
            });


        },

        load() {
            this.$util.load(this, {
                service: 'configuracoes',
                func: 'check',
                parms: {
                    st_slug: 'dmed-fracionado',
                    st_valor: 1,
                },
                loadTo: res => {
                    if (res) {
                        this.dmed_fracionado = true;
                    } else {
                        this.dmed_fracionado = false;
                    }
                }
            });

        }

    },

    gerarDMEDSemFracionar() {
        if (this.retificadora == "S" && this.recibo == "") {
            this.$toast.add({
                severity: "error",
                summary: "Atenção",
                detail: "Informe o número do recibo",
                life: 3000
            });
            return;
        }

        this.$store.commit("loading", true);

        var data = {
            referencia: this.referencia,
            calendario: this.calendario,
            retificadora: this.retificadora,
            recibo: this.recibo,
            status_lancamento: this.status_lancamento,
            filtro_nota_fiscal: this.filtro_nota_fiscal,
            unidade_operacao: this.unidade_operacao
        };

        return this.axios
            .post("/dmed/arquivo", data)
            .then(res => {
                if (res.status == 200 || res.status == 201) {

                    if (res.data.status_code == 406) {
                        this.$toast.add({
                            severity: "error",
                            summary: "Atenção",
                            detail: res.data.msg,
                            life: 3000
                        });
                        return;
                    }

                    var dataStr = "data:text/plain;charset=utf-8," + encodeURIComponent(res.data);
                    var downloadAnchorNode = document.createElement('a');
                    downloadAnchorNode.setAttribute("href", dataStr);
                    downloadAnchorNode.setAttribute("download", "dmed" + this.referencia + ".txt");
                    document.body.appendChild(downloadAnchorNode);
                    downloadAnchorNode.click();
                    downloadAnchorNode.remove();

                    this.$toast.add({
                        severity: "success",
                        summary: "Atenção",
                        detail: "Arquivo DMED gerado com sucesso.",
                        life: 3000
                    });
                }
            })
            .finally(() => {
                this.$store.commit("loading", false);
            });
    },

    gerarDMEDFracionado() {
        if (this.retificadora == "S" && this.recibo == "") {
            this.$toast.add({
                severity: "error",
                summary: "Atenção",
                detail: "Informe o número do recibo",
                life: 3000
            });
            return;
        }

        this.$store.commit("loading", true);

        let referencia = this.referencia;
        let calendario = this.calendario;
        let retificadora = this.retificadora;
        let recibo = this.recibo;
        let status_lancamento = this.status_lancamento;
        let unidade_operacao = this.unidade_operacao;
        let filtro_nota_fiscal = this.filtro_nota_fiscal;

        this.chave = this.$util.uuidv4();
        const infos = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(mes => {
            return {
                referencia: referencia,
                calendario: calendario,
                retificadora: retificadora,
                recibo: recibo,
                status_lancamento: status_lancamento,
                filtro_nota_fiscal: filtro_nota_fiscal,
                unidade_operacao: unidade_operacao,
                mes: mes
            };
        });

        this.$refs.dispatch.executar_chunck(
            'financeiro',
            'save_dmed_aux_table',
            infos,
            '',
            {},
            1
        );

        this.$store.commit("loading", false);
    },

    terminar_captura() {
        let data = {
            referencia: this.referencia,
            calendario: this.calendario,
            retificadora: this.retificadora,
            recibo: this.recibo,
            status_lancamento: this.status_lancamento,
            unidade_operacao: this.unidade_operacao
        };

        this.axios.post("/dmed/arquivo", data)
            .then(res => {
                if (res.status == 200 || res.status == 201) {
                    if (res.data.status_code == 406) {
                        this.$toast.add({
                            severity: "error",
                            summary: "Atenção",
                            detail: res.data.msg,
                            life: 3000
                        });
                        return;
                    }

                    var dataStr = "data:text/plain;charset=utf-8," + encodeURIComponent(res.data);
                    var downloadAnchorNode = document.createElement('a');
                    downloadAnchorNode.setAttribute("href", dataStr);
                    downloadAnchorNode.setAttribute("download", "dmed" + this.referencia + ".txt");
                    document.body.appendChild(downloadAnchorNode);
                    downloadAnchorNode.click();
                    downloadAnchorNode.remove();

                    this.$toast.add({
                        severity: "success",
                        summary: "Atenção",
                        detail: "Arquivo DMED gerado com sucesso.",
                        life: 3000
                    });
                }
            })
            .catch(() => {
                this.loading = false;
                this.reloading = false;
            });
    },

    mounted() {
        this.$store.commit("setBreadcrumb", [
            { name: "Financeiro", path: "/financeiro" },
            { name: "DMED", path: "/financeiro/dmed" }
        ]);
        this.load();
    }


};
</script>
